import { FC } from 'react'
import styled from 'styled-components'
import Button from '@app.components/Button'
import { ButtonProps } from '@app.components/Button/Button'
import PredictionArrow from 'svgIcons/PredictionArrow'

interface PredictionButtonProps extends ButtonProps {}

const PredictionButton: FC<PredictionButtonProps> = ({
  children,
  color = 'prediction',
  ...props
}) => {
  return (
    <StyledWrapper
      color={color}
      {...props}
      endIcon={<PredictionArrow className="arrow-icon" />}
    >
      <span>{children}</span>
    </StyledWrapper>
  )
}

export default PredictionButton

const StyledWrapper = styled(Button)`
  width: 100%;
  height: 50px;
  border-radius: 8px;
  gap: 4px;

  .arrow-icon {
    width: 18px;
    height: 18px;
  }

  > span {
    font-size: 16px;
    font-weight: bold;
    letter-spacing: -0.64px;
    text-align: center;
  }
`
